var app = angular.module("leonardo");

var WorkOrderListFilters = function(
  $rootScope,
  $scope,
  $controller,
  WorkOrderService,
  UnitService,
  WorkOrderCVService,
  AccountUserService,
  PropertyService
) {

  $controller('FiltersBaseController', {$scope: $scope});

  function tryApplyIframeSelectedProperty() {
    if (!$rootScope.isInIframe) {
      return;
    }
    var raw = null;
    var parsed = null;
    try {
      raw = window.sessionStorage.getItem('iframe_filter_data');
      if (!raw) {
        return;
      }
      parsed = JSON.parse(raw);
    } catch (e) {
      return;
    }
    
    if (parsed && parsed.selected_property_id) {
      window.sessionStorage.removeItem('iframe_filter_data');
      $scope.filterService.setFilter('property_reports', parsed.selected_property_id, true);
      PropertyService.get(parsed.selected_property_id).then(function (property) {
        if (property && property.pms_platform && property.pms_platform.id) {
          $scope.filterService.setFilter('pms_platform', property.pms_platform.id, true);
        }
      });
    }
  }

  tryApplyIframeSelectedProperty();

  if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty) {
    $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
    $scope.filterService.setFilter('pms_platform', $scope.filterService.currentProperty.pms_platform.id, true);
  }

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: false,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      group: 'created_date',
      name: 'Created Date',
      elements: [
        {
          id: 'created_from_date',
          name: 'Created Date From',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Created Date From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'created_to_date'
        },
        {
          id: 'created_to_date',
          name: 'Created Date To',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Created Date To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'created_from_date'
        },
        {
          id: 'created_date_range',
          name: 'Created Dates Range',
          label: null,
          inline: false,
          type: 'date_range',
          placeholder: 'Created Dates Range',
          condition: true,
          conflicts: [],
          startDate: 'created_from_date',
          endDate: 'created_to_date'
        },
        {
          id: 'origin',
          name: 'Origin',
          label: null,
          inline: false,
          type: 'options',
          multiple: false,
          placeholder: 'origin',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          serviceParams: { property: $scope.filterService.getFilter('property_reports') },
          options:[
            { id: 'leo', name: 'Leo' },
            { id: 'latchel', name: 'Latchel' },
            { id: 'pms', name: 'PMS' },        
          ],
          conflicts: []
        },
      ]
    },
    {
      group: 'due_date',
      name: 'Due Date',
      elements: [
        {
          id: 'from_date',
          name: 'Due Date From',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Due Date From',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          endDate: 'to_date'
        },
        {
          id: 'to_date',
          name: 'Due Date To',
          label: null,
          inline: false,
          type: 'date',
          placeholder: 'Due Date To',
          condition: true,
          conflicts: [],
          positionVertical: 'bottom',
          startDate: 'from_date'
        },
        {
          id: 'date_range',
          name: 'Due Dates Range',
          label: null,
          inline: false,
          type: 'date_range',
          placeholder: 'Due Dates Range',
          condition: true,
          conflicts: [],
          startDate: 'from_date',
          endDate: 'to_date'
        }
      ]
    },
    {
      id: 'account_users_assigned',
      name: 'Assigned user',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Assigned user',
      modeUser: true,
      service : AccountUserService,
      serviceParams: {disable_pagination: true, essential: true, user_is_active: true, property: $scope.filterService.getFilter('property')},
      serviceFunction: AccountUserService.getAvailableToAssign,
      condition: true,
      conflicts: []
    },
    {
      id: 'name',
      name: 'Brief Description',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Brief Description',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'building_number',
      name: 'Building Number',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Building number',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      service: WorkOrderCVService,
      serviceParams: { type: 2, property: $scope.filterService.getFilter('property_reports') },
      conflicts: []
    },
    {
      id: 'completed_date',
      name: 'Completed Date',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Completed Date',
      condition: true,
      conflicts: [],
      positionVertical: 'bottom'
    },
    {
      id: 'service_request_date',
      name: 'Created Date',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Created Date',
      condition: true,
      conflicts: [],
      positionVertical: 'bottom'
    },
    {
      id: 'due_date',
      name: 'Due Date',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Due Date',
      condition: true,
      conflicts: [],
      positionVertical: 'bottom'
    },
    {
      id: 'exclude_completed',
      name: 'Exclude Completed',
      label: null,
      inline: false,
      type: 'checkbox',
      condition: true,
      onSubmit: $scope.filter
    },
    {
      id: 'external_id',
      name: 'External ID',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'External ID',
      condition: true,
      onSubmit: $scope.filter,
      conflicts: []
    },
    {
      id: 'last_modified_by',
      name: 'Last Modified By',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Last Modified By',
      modeUser: true,
      service : AccountUserService,
      serviceParams: {disable_pagination: true, essential: true, user_is_active: true, property: $scope.filterService.getFilter('property')},
      serviceFunction: AccountUserService.getAvailableToAssign,
      condition: true,
      conflicts: []
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      service: WorkOrderCVService,
      serviceParams: { type: 0, property: $scope.filterService.getFilter('property_reports') },
      conflicts: []
    },
    {
      id: 'status',
      name: 'Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Select Status',
      condition: true,
      service: WorkOrderCVService,
      serviceParams: { type: 1, property: $scope.filterService.getFilter('property_reports') },
      conflicts: []
    },
    {
      id: 'type',
      name: 'Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Types',
      condition: true,
      options: WorkOrderService.TYPE_OPTIONS,
      conflicts: []
    },
    {
      id: 'unit',
      name: 'Unit',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Select Unit',
      condition: $scope.filterService.hasFilter('property_reports'),
      service: UnitService,
      serviceParams: { property: $scope.filterService.getFilter('property_reports') },
      serviceFunction: UnitService.getAllByProperty,
      conflicts: []
    }
  ];
  
  $scope.filterService.showFilters(['property_reports', 'status', 'category', 'priority', 'external_id', 'name', 'unit', 'service_request_date', 'due_date', 'exclude_completed','origin']);
  $scope.filterService.setFilter('exclude_completed', true, true);
  var filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];

  if (!angular.isArray(filters)) {
    filters = filters.split(',');
  }

  if (!_.contains(filters,'property_reports')) {
    filters.push('property_reports');
  }

  $scope.filterService.setFilter('filters', filters, true);

  $scope.$on('filter-service:filter-changed', function ($event, key, value) {

    if (key === 'property_reports') {
      var changed_filters = angular.copy($scope.filters_options);
      angular.forEach(changed_filters, function(filter){
        if (['unit','priority','category','status','account_users_assigned','last_modified_by'].includes(filter.id)){
          filter.serviceParams.property = value;

        }
        if (['unit'].includes(filter.id)){
          filter.condition = true;
        }
      });
      $scope.filters_options = changed_filters;
      PropertyService.get(value).then(function (property) {
         $scope.filterService.setFilter('pms_platform', property.pms_platform.id, true);
      });
    }
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    if (key === 'property_reports') {
      var removed_filters = angular.copy($scope.filters_options);
      angular.forEach(removed_filters, function(filter){
        if (['unit','priority','category','status','account_users_assigned','last_modified_by'].includes(filter.id)){
          filter.serviceParams.property = undefined;
        }
        if (['unit'].includes(filter.id)){
          filter.condition = false;
          $scope.filterService.removeFilter(filter.id);
        }
      });
      $scope.filters_options = removed_filters;
    }
  });
};

app.controller('WorkOrderListFilters', [
  '$rootScope',
  '$scope',
  '$controller',
  'WorkOrderService',
  'UnitService',
  'WorkOrderCVService',
  'AccountUserService',
  'PropertyService',
  WorkOrderListFilters
]);
